import { render, staticRenderFns } from "./dialog-manageheaderoutbox.vue?vue&type=template&id=3aead0e7&"
import script from "./dialog-manageheaderoutbox.vue?vue&type=script&lang=js&"
export * from "./dialog-manageheaderoutbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports